class CustomError extends Error {
  private code: number;
  private statusText: string;

  constructor(code: number, statusText: string) {
    super(
      `Something went wrong. The query returned an error ${[code, statusText]
        .filter((e) => e)
        .join("-")}`
    );
    this.code = code;
    this.statusText = statusText;
  }

  getCode() {
    return this.code;
  }

  getStatusText() {
    return this.statusText;
  }
}

export default CustomError;
